import { getBooking } from "../../../app/api/getBooking";
import { patchBookingPromotionCodes } from "../../../app/api/patchBookingPromotionCodes";
import { updateRecoilState } from "../../../Orchestrator/Recoils/Events/Recoil";
import { IBooking } from "../../../Orchestrator/Types/Index";
import { IBookingResponse } from "../../../Orchestrator/Types/Types/BookingTypes";
import { prepareBookingSummaryAction } from "../Checkout/Summary/PrepareBookingSummaryAction";

/** Codes the booking reports as applied, across admissions, reservations and ancillaries. */
export function getAppliedPromoCodes(booking?: IBooking): string[] {
    const codes = new Set<string>();
    (booking?.bookedOffers || []).forEach((offer: any) => {
        [...(offer?.admissions || []), ...(offer?.reservations || []), ...(offer?.ancillaries || [])]
            .forEach((part: any) => {
                (part?.appliedPromotionCodes || []).forEach((promo: any) => {
                    const code = typeof promo === "string" ? promo : promo?.code;
                    if (code) codes.add(code);
                });
            });
    });
    return Array.from(codes);
}

/**
 * PATCHes the booking with the full list of promotion codes, then reloads the
 * booking and the payment summary the same way the voucher actions do.
 * Returns the refreshed booking, or undefined when the PATCH failed.
 */
export async function updateBookingPromoCodes(bookingId: string, promoCodes: string[]): Promise<IBooking | undefined> {
    const response: any = await patchBookingPromotionCodes(bookingId, promoCodes);
    if (response.status !== "ok") {
        return undefined;
    }
    const bookingResponse: any = await getBooking(bookingId);
    if (bookingResponse.status !== "ok" || !bookingResponse.answer) {
        return undefined;
    }
    const { booking }: IBookingResponse = bookingResponse.answer;
    updateRecoilState("bookingResponseAtom", bookingResponse.answer);

    const isOnHoldBooking = (booking?.bookedOffers || []).some(offer =>
        (offer?.admissions || []).some(admission => admission?.status === "ON_HOLD")
    );
    prepareBookingSummaryAction.setParams({
        ...booking,
        ...(isOnHoldBooking ? { isFrom: "on-hold-booking" as const } : {})
    });
    await prepareBookingSummaryAction.execute();

    updateRecoilState("listOfAppliedPromoCodeAtom", getAppliedPromoCodes(booking));
    return booking;
}
